<template>
  <router-view/>
</template>

<script>
export default {
	name: 'App',
	mounted: function () {
		// document.domain = 'https://cp.zhgcloud.com' 
		this.table_height();
	},
	// 事件
	methods: {
		table_height() {
			var this_ = this;
			var winHeight;
			var chazhi = 70 + 62 + 65 + 68 + 66 + 60;
			if (window.innerHeight) {
				winHeight = window.innerHeight;
			} else if ((document.body) && (document.body.clientHeight)) {
				winHeight = document.body.clientHeight;
			}
			if (document.documentElement && document.documentElement.clientHeight) {
				winHeight = document.documentElement.clientHeight;
			}
			sessionStorage.setItem('table_height', winHeight - chazhi);
			window.onresize = () => {
				return (() => {
					this_.$nextTick(function () {
						if (window.innerHeight) {
							winHeight = window.innerHeight;
						} else if ((document.body) && (document.body.clientHeight)) {
							winHeight = document.body.clientHeight;
						}
						if (document.documentElement && document.documentElement.clientHeight) {
							winHeight = document.documentElement.clientHeight;
						}
						sessionStorage.setItem('table_height', winHeight - chazhi);
						if (this_.$refs.child&&this_.$refs.child.headHeight) {
							this_.$refs.child.headHeight();
						}
					})
				})()
			}
		},
	},
}
</script>

<style>
.el-checkbox__inner{
	border-color: #000;
}
.table-fullscreen{
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh!important;
	z-index: 1000;
	background-color: #fff;
}
.table-fullscreen.table_kuang{
	margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue